import { render, staticRenderFns } from "./createElevator.vue?vue&type=template&id=78719324&scoped=true"
import script from "./createElevator.vue?vue&type=script&lang=js"
export * from "./createElevator.vue?vue&type=script&lang=js"
import style0 from "./createElevator.vue?vue&type=style&index=0&id=78719324&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78719324",
  null
  
)

export default component.exports